import React, { Component } from 'react';
import { Row, Col, Form, Button, Toast, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync, faSearch, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle, faTimesCircle, faUser, faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import swal from 'sweetalert';
import customerService from './customerService';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';

import './customerViewStyle.scss';
import SubHeader from './../../../../Layout/SubHeader';
import { Config } from '../../../../../shared/config';

import ToggleButton from 'react-toggle-button';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Whitelist from '../sftp/whitelist';
import SftpUserlist from '../sftp/sftpUserList';
import NotificationList from '../Notification/notification';

class CustomerView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showError: false,
            showEmailError: false,
            customerData: null,
            showToast: false,
            validator: {
                customerName: false,
                s3BucketName: false,
                customerType: true,
                status: true,
                fieldTherigyStmIntUser: true,
            },
            api: {
                response: {
                    status: '',
                    message: '',
                },
            },
            showCustomerList: false,
            showUserList: false,
            fieldCustomerID: null,
            fieldSearchCustomer: '',
            fieldCustomerName: '',
            fieldAddressLine1: '',
            fieldAddressLine2: '',
            fieldCity: '',
            fieldState: '',
            fieldZip: '',
            fieldCustomerType: '',
            fieldS3BucketName: '',
            fieldStatus: '',
            companyWebsite: '',
            therigyStmIntUser: '',
            disableRefreshButton: false,
            showRefreshLoader: false,
            createdDate: '',
            modifiedDate: '',
            companyLogo: null,
            customersList: [],
            userList: [],
            enableSFTP: false,
            redox: false,
            appointmentReferral: false,
            searchBySelected: ['Company'],
            crmParentId: '',
            showAppointmentReferral: false,
            pgpEnabled: false,
        };
        this.onSelectLogo = this.onSelectLogo.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleClickUserOutside = this.handleClickUserOutside.bind(this);
        this.setCustomerWrapperRef = this.setCustomerWrapperRef.bind(this);
        this.setUserWrapperRef = this.setUserWrapperRef.bind(this);
        this.handleSearchBySelectedClick = this.handleSearchBySelectedClick.bind(this);
        this.customerService = new customerService();
    }

    /**
     * Triggers On change of the image file.
     */
    onSelectLogo(event) {
        const file = event.target.files[0];
        if (file) {
            //converting the size to mb by 1048576 bytes
            const fileSize = file.size / 1048576;
            if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
                if (fileSize > 5) {
                    swal({
                        title: 'Failed',
                        text: 'Maximum filesize exceeded.',
                        icon: 'warning',
                        button: 'OK',
                    });
                } else {
                    convertLogoToBase64(event.target.files[0]).then((result) => {
                        var img = new Image();
                        img.src = result;

                        img.onload = () => {
                            if (img.width <= 130 && img.height <= 40) {
                                this.setState({
                                    fieldCompanyLogo: result,
                                });
                            } else {
                                swal({
                                    title: 'Failed',
                                    text: 'Unsupported file resolution',
                                    icon: 'warning',
                                    button: 'OK',
                                });
                            }
                        };
                    });
                }
            } else {
                swal({
                    title: 'Failed',
                    text: 'Invalid file format',
                    icon: 'warning',
                    button: 'OK',
                });
            }
        }
    }

    /**
     * Triggers On change of the input fields value.
     */
    handleInputChange = (event) => {
        const value = event.target.value;
        const name = event.target.name;
        let { validator } = this.state;

        if (value === '') {
            if (name === 'fieldCustomerType') {
                validator.customerType = false;
            }
            if (name === 'fieldStatus') {
                validator.status = false;
            }
            if (name === 'fieldS3BucketName') {
                validator.s3BucketName = false;
            }
        } else {
            if (name === 'fieldSearchCustomer' && !this.props.match.params.customerId) {
                this.customerSearch(value);
            }
            if (name === 'fieldCustomerType') {
                validator.customerType = true;
            }
            if (name === 'fieldStatus') {
                validator.status = true;
            }
            if (name === 'fieldS3BucketName') {
                validator.s3BucketName = true;
            }
            if (name === 'fieldTherigyStmIntUser') {
                this.userSearch(value);
            }
        }

        this.setState({
            validator,
        });

        this.setState({
            [name]: value,
        });
    };

    /**
     * Triggers On change of the input fields value.
     */
    handleFocusOutChange = (event) => {
        const value = event.target.value;
        const name = event.target.name;
        let { validator } = this.state;

        if (this.validEmailRegex.test(value)) {
            validator.therigyStmIntUser = false;
            this.setState({
                validator,
                [name]: value,
                showEmailError: false,
                showUserList: false,
            });
        } else {
            validator.therigyStmIntUser = true;
            this.setState({
                validator,
                [name]: value,
                showEmailError: true,
            });
        }
    };

    /**
     * Triggers On customer search field value changes.
     */
    customerSearch(searchKey) {
        const { searchBySelected } = this.state;
        if (searchKey != null) {
            this.customerService.getCustomers(searchKey, searchBySelected[0]).then((res) => {
                if (res.status === 'Success' && res.data.length > 0) {
                    this.setState({
                        showCustomerList: true,
                        customersList: res.data,
                    });
                } else {
                    this.setState({
                        customersList: [],
                    });
                }
            });
        }
    }

    /**
     * Triggers On customer search field value changes.
     */
    userSearch(searchKey) {
        const { fieldCustomerName } = this.state;
        if ((searchKey != null) & (fieldCustomerName != null)) {
            this.customerService.searchUserByCustomerId(searchKey, this.props.match.params.customerId).then((res) => {
                if (res.status === 'Success' && res.data.length > 0) {
                    this.setState({
                        showUserList: true,
                        userList: res.data,
                    });
                } else {
                    this.setState({
                        userList: [],
                    });
                }
            });
        }
    }

    /**
     * Toggle toast
     */
    toggleToast = () => {
        const { showToast } = this.state;
        this.setState({
            showToast: !showToast,
        });
        setTimeout(() => {
            this.setState({
                showToast: false,
            });
        }, 4000);
    };

    /**
     * Toggle toast
     */
    toggleToastPGP = () => {
        setTimeout(() => {
            this.setState({
                showToast: false,
            });
        }, 4000);
    };

    /**
     * Triggers when customer selected from search list.
     */
    onRowClick = (row) => {
        const { validator, searchBySelected } = this.state;
        this.setState({
            fieldCustomerID: row.original.crmCustomerId,
            fieldCustomerName: row.original.customerName,
            fieldAddressLine1: row.original.addressLine1,
            fieldAddressLine2: row.original.addressLine2,
            fieldCity: row.original.city,
            fieldState: row.original.state,
            fieldZip: row.original.zip,
            customersList: [],
            validator: {
                customerType: validator.customerType,
                status: validator.status,
            },
        });

        if (searchBySelected.includes('Branch')) {
            this.setState({
                crmParentId: row.original.crmParentId,
            });
        }
    };

    /**
     * Triggers when customer selected from search list.
     */
    onUserRowClick = (row) => {
        this.setState({
            fieldTherigyStmIntUser: row.original.emailAddress,
            showUserList: false,
            showEmailError: false,
        });
    };

    toggleSFTP = (enableSFTP) => {
        this.setState({
            enableSFTP: enableSFTP,
        });
    };

    toggleRedOx = (redox) => {
        this.setState({
            redox: redox,
        });
    };

    toggleAppointmentReferral = (appointmentReferral) => {
        if (this.props.match.params.customerId) {
            this.setState({
                appointmentReferral: appointmentReferral,
                showEmailError: false,
            });
        } else {
            this.setState({
                appointmentReferral: appointmentReferral,
                showEmailError: false,
                fieldTherigyStmIntUser: '',
            });
        }
    };

    togglePGP = (pgpEnabled) => {
        this.setState({
            pgpEnabled: pgpEnabled,
            showToast: true,
        });

        let params = {
            customerId: this.props.match.params.customerId,
            pgpEnabled: pgpEnabled === true ? 1 : 0,
        };

        this.customerService.updateCustomerPGP(params).then((res) => {
            if (res && res.status === 'Success') {
                this.setState({
                    showError: false,
                    api: {
                        response: {
                            status: 'Success',
                            message: 'Updated  Successfully',
                        },
                    },
                });
                this.toggleToastPGP();
                console.info(' Success ');
            } else {
                console.info(' Error ');
            }
        });
    };

    /* Email validation regex */
    validEmailRegex = RegExp(
        '^(([^<>()[]\\.,;:s@]+(.[^<>()[]\\.,;:s@]+)*)|(.+))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$',
    ); // eslint-disable-line

    /**
     * Rendering ui elements
     */
    render() {
        let showSearch = true;
        if (this.props.match && this.props.match.params.customerId) {
            showSearch = false;
        }
        const {
            fieldCustomerID,
            fieldSearchCustomer,
            fieldCustomerName,
            fieldAddressLine1,
            fieldAddressLine2,
            fieldCity,
            fieldState,
            fieldZip,
            fieldCustomerType,
            fieldS3BucketName,
            fieldStatus,
            fieldCompanyWebsite,
            fieldTherigyStmIntUser,
            fieldCompanyLogo,
            showCustomerList,
            createdDate,
            modifiedDate,
            validator,
            showError,
            disableRefreshButton,
            showRefreshLoader,
            api,
            showToast,
            customerData,
            customersList,
            enableSFTP,
            redox,
            searchBySelected,
            appointmentReferral,
            showEmailError,
            showUserList,
            userList,
            showAppointmentReferral,
            pgpEnabled,
        } = this.state;
        const displayCustomerList = showCustomerList ? 'd-block' : 'd-none';
        const displayUserList = showUserList ? 'd-block' : 'd-none';
        const displayCreatedInfo = customerData && customerData.customerId ? 'd-block' : 'd-block';
        const searchPlaceHolder = searchBySelected.includes('Company')
            ? 'Customer Search by Company Name'
            : 'Customer Search by Branch Name';

        const searchColumns = searchBySelected.includes('Company')
            ? [
                  {
                      Header: 'Customer ID',
                      accessor: 'crmCustomerId',
                  },
                  {
                      Header: 'Customer Name',
                      accessor: 'customerName',
                  },
              ]
            : [
                  {
                      Header: 'Customer ID',
                      accessor: 'branchId',
                  },
                  {
                      Header: 'Customer Name',
                      accessor: 'branchName',
                  },
                  {
                      Header: 'Parent ID',
                      accessor: 'crmParentId',
                  },
                  {
                      Header: 'Parent Name',
                      accessor: 'parentName',
                  },
              ];

        let saveDisabled = true;

        if (appointmentReferral) {
            saveDisabled = !showEmailError & (fieldTherigyStmIntUser != '');
        } else {
            saveDisabled = !showEmailError;
        }

        if (userList && fieldTherigyStmIntUser) {
            const foundEmail = userList.find((obj) => obj.emailAddress === fieldTherigyStmIntUser);
            if (foundEmail) {
                saveDisabled = true;
            } else {
                saveDisabled = false;
            }
        }

        const userColumns = [
            {
                Header: 'Email',
                accessor: 'emailAddress',
            },
        ];

        return (
            <div className="dummy customer-view">
                <Row>
                    <Col md={12}>
                        <SubHeader customerNameRoute={fieldCustomerName} />
                    </Col>
                </Row>
                <div className="tab-container">
                    <Tabs selectedIndex={0} className="pt-2 pl-3 bg-white">
                        <Tab eventKey="sftp-user-list" className="bg-white" title="Customer">
                            <div className="add-customer-outer">
                                <Row className="toast-container">
                                    <Col md={12} className="pt-2">
                                        <Toast className="toast-container" show={showToast} onClose={this.toggleToast}>
                                            <Toast.Header
                                                className={` ${
                                                    api.response.status !== 'Failure' ? 'success' : 'error'
                                                }`}
                                            >
                                                <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
                                                <strong className="mr-auto">{api.response.status}</strong>
                                            </Toast.Header>
                                            <Toast.Body>{api.response.message}</Toast.Body>
                                        </Toast>
                                    </Col>
                                </Row>
                                <Row className="body-pane">
                                    <Col sm={12} md={6}>
                                        <Row>
                                            <Col sm={12}>
                                                {showSearch ? (
                                                    <Form.Group className="form-inline pt-2 mb-lg-3">
                                                        <Form.Label
                                                            column
                                                            sm={3}
                                                            className="justify-content-start model-field-label text-nowrap"
                                                        >
                                                            Search By
                                                        </Form.Label>
                                                        <div className="search-by">
                                                            <input
                                                                type="radio"
                                                                id="company-search"
                                                                name="search"
                                                                value="Company"
                                                                checked={searchBySelected.includes('Company')}
                                                                onClick={(event) =>
                                                                    this.handleSearchBySelectedClick(event)
                                                                }
                                                            />
                                                            <label className="radio-lable" htmlFor="company-search">
                                                                Company
                                                            </label>
                                                            <br />
                                                            <input
                                                                type="radio"
                                                                id="branch-search"
                                                                name="search"
                                                                value="Branch"
                                                                checked={searchBySelected.includes('Branch')}
                                                                onClick={(event) =>
                                                                    this.handleSearchBySelectedClick(event)
                                                                }
                                                            />
                                                            <label className="radio-lable" htmlFor="branch-search">
                                                                Branch
                                                            </label>
                                                            <br />
                                                        </div>
                                                    </Form.Group>
                                                ) : null}
                                            </Col>
                                            <Col sm={12}>
                                                {showSearch ? (
                                                    <Form.Group className="form-inline pt-2 mb-lg-3">
                                                        <Form.Label
                                                            column
                                                            sm={3}
                                                            className="justify-content-start model-field-label text-nowrap"
                                                        >
                                                            Search
                                                        </Form.Label>
                                                        <Col sm={9} className="text-left">
                                                            <div className="customer-search-wrapper">
                                                                <Form.Control
                                                                    id="search-text"
                                                                    type="text"
                                                                    size="sm"
                                                                    placeholder={searchPlaceHolder}
                                                                    name="fieldSearchCustomer"
                                                                    value={fieldSearchCustomer || ''}
                                                                    autoComplete="none"
                                                                    onChange={this.handleInputChange}
                                                                />
                                                                <FontAwesomeIcon
                                                                    icon={faSearch}
                                                                    className="search-icon search-icon-box"
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Form.Group>
                                                ) : null}
                                                {customersList && customersList.length ? (
                                                    <Col className="text-left col-12">
                                                        <div
                                                            className={`customer-search-box ${displayCustomerList}`}
                                                            ref={this.setCustomerWrapperRef}
                                                        >
                                                            <ReactTable
                                                                columns={searchColumns}
                                                                data={customersList}
                                                                loading={false}
                                                                minRows={
                                                                    customersList.length ? customersList.length : 0
                                                                }
                                                                showPagination={false}
                                                                pageSize={
                                                                    customersList.length ? customersList.length : 0
                                                                }
                                                                className="-striped -highlight h-100 cursor-pointer"
                                                                getTrProps={(state, rowInfo) => {
                                                                    return {
                                                                        onClick: () => {
                                                                            this.onRowClick(rowInfo);
                                                                        },
                                                                    };
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>
                                                ) : null}
                                            </Col>

                                            <Col sm={showSearch ? 12 : 8}>
                                                <Form.Group className="form-inline">
                                                    <Form.Label
                                                        column
                                                        sm={showSearch ? 3 : 5}
                                                        className="justify-content-start model-field-label text-nowrap required"
                                                    >
                                                        CRM Customer ID
                                                    </Form.Label>
                                                    <Col
                                                        sm={showSearch ? 9 : 7}
                                                        className={showSearch ? 'text-left' : 'text-left pl-0 pr-0'}
                                                    >
                                                        <Form.Control
                                                            id="customer-id"
                                                            type="text"
                                                            size="sm"
                                                            disabled
                                                            placeholder="CRM Customer ID"
                                                            name="fieldCustomerID"
                                                            value={fieldCustomerID || ''}
                                                            autoComplete="none"
                                                        />
                                                    </Col>
                                                </Form.Group>
                                            </Col>
                                            {!showSearch ? (
                                                <Col sm={4}>
                                                    <Button
                                                        className="btn-refresh"
                                                        size="md"
                                                        disabled={disableRefreshButton ? 'disabled' : null}
                                                        onClick={this.refreshDataFromCRM}
                                                    >
                                                        {showRefreshLoader ? (
                                                            <div
                                                                className="spinner-border spinner-border-sm text-white"
                                                                role="status"
                                                            >
                                                                <span className="sr-only">Loading...</span>
                                                            </div>
                                                        ) : (
                                                            <FontAwesomeIcon icon={faSync} />
                                                        )}
                                                        <span className="ml-3">Refresh from CRM</span>
                                                    </Button>
                                                </Col>
                                            ) : null}
                                            <Col sm={12}>
                                                <Form.Group className="form-inline">
                                                    <Form.Label
                                                        column
                                                        sm={3}
                                                        className="justify-content-start model-field-label text-nowrap required"
                                                    >
                                                        Customer Name
                                                    </Form.Label>
                                                    <Col sm={9} className="text-left">
                                                        <Form.Control
                                                            id="customer-name"
                                                            type="text"
                                                            size="sm"
                                                            placeholder="Customer Name"
                                                            name="fieldCustomerName"
                                                            disabled
                                                            value={fieldCustomerName || ''}
                                                            autoComplete="none"
                                                        />
                                                    </Col>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={12}>
                                                <Form.Group className="form-inline">
                                                    <Form.Label
                                                        column
                                                        sm={3}
                                                        className="justify-content-start model-field-label text-nowrap"
                                                    >
                                                        Address Line 1
                                                    </Form.Label>
                                                    <Col sm={9} className="text-left">
                                                        <Form.Control
                                                            id="address-line-1"
                                                            type="text"
                                                            size="sm"
                                                            placeholder="Address Line 1"
                                                            name="fieldAddressLine1"
                                                            disabled
                                                            value={fieldAddressLine1 || ''}
                                                            autoComplete="none"
                                                        />
                                                    </Col>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={12}>
                                                <Form.Group className="form-inline">
                                                    <Form.Label
                                                        column
                                                        sm={3}
                                                        className="justify-content-start model-field-label text-nowrap"
                                                    >
                                                        Address Line 2{' '}
                                                    </Form.Label>
                                                    <Col sm={9} className="text-left">
                                                        <Form.Control
                                                            id="address-line-2"
                                                            type="text"
                                                            size="sm"
                                                            placeholder="Address Line 2"
                                                            name="fieldAddressLine2"
                                                            disabled
                                                            value={fieldAddressLine2 || ''}
                                                            autoComplete="none"
                                                        />
                                                    </Col>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={12}>
                                                <Form.Group className="form-inline">
                                                    <Form.Label
                                                        column
                                                        sm={3}
                                                        className="justify-content-start model-field-label text-nowrap"
                                                    >
                                                        City
                                                    </Form.Label>
                                                    <Col sm={9} className="text-left">
                                                        <Form.Control
                                                            id="customer-city"
                                                            type="text"
                                                            size="sm"
                                                            placeholder="City"
                                                            name="fieldCity"
                                                            disabled
                                                            value={fieldCity || ''}
                                                            autoComplete="none"
                                                        />
                                                    </Col>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={12}>
                                                <Form.Group className="form-inline">
                                                    <Form.Label column sm={3} className="model-field-label">
                                                        State
                                                    </Form.Label>
                                                    <Col sm={4} className="text-left">
                                                        <Form.Control
                                                            id="customer-state"
                                                            type="text"
                                                            size="sm"
                                                            placeholder="State"
                                                            name="fieldState"
                                                            disabled
                                                            value={fieldState || ''}
                                                            autoComplete="none"
                                                        />
                                                    </Col>
                                                    <Form.Label column sm={1} className="model-field-label">
                                                        Zip{' '}
                                                    </Form.Label>
                                                    <Col sm={4} className="text-left">
                                                        <Form.Control
                                                            id="customer-zip"
                                                            type="text"
                                                            size="sm"
                                                            placeholder="Zip"
                                                            name="fieldZip"
                                                            value={fieldZip || ''}
                                                            disabled
                                                            autoComplete="none"
                                                        />
                                                    </Col>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col sm={12} md={6}>
                                        <Row>
                                            <Col sm={12}>
                                                <Form.Group className="form-inline">
                                                    <Form.Label
                                                        column
                                                        sm={3}
                                                        className="model-field-label text-nowrap required"
                                                    >
                                                        Customer Type
                                                    </Form.Label>
                                                    <Col sm={9} className="text-left">
                                                        <Form.Control
                                                            id="customer-type"
                                                            as="select"
                                                            size="sm"
                                                            name="fieldCustomerType"
                                                            value={fieldCustomerType || ''}
                                                            onChange={this.handleInputChange}
                                                        >
                                                            <option value="PHARMACY">PHARMACY</option>
                                                            <option value="TEST">TEST</option>
                                                        </Form.Control>
                                                        {!validator.customerType && showError ? (
                                                            <span className="error">Customer Type is required</span>
                                                        ) : null}
                                                    </Col>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={12}>
                                                <Form.Group className="form-inline">
                                                    <Form.Label
                                                        column
                                                        sm={3}
                                                        className="model-field-label text-nowrap required"
                                                        title="AWS S3 Bucket Name"
                                                    >
                                                        Data File Location
                                                    </Form.Label>
                                                    <Col sm={9} className="text-left">
                                                        <Form.Control
                                                            id="customer-file-location"
                                                            type="text"
                                                            size="sm"
                                                            placeholder="Data file location"
                                                            name="fieldS3BucketName"
                                                            value={fieldS3BucketName || ''}
                                                            onChange={this.handleInputChange}
                                                            autoComplete="none"
                                                        />
                                                        {!validator.s3BucketName && showError ? (
                                                            <span className="error">
                                                                Data File Location is required
                                                            </span>
                                                        ) : null}
                                                    </Col>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={12}>
                                                <Form.Group className="form-inline" controlId="fieldStatus">
                                                    <Form.Label
                                                        column
                                                        sm={3}
                                                        className="model-field-label text-nowrap required"
                                                    >
                                                        Status
                                                    </Form.Label>
                                                    <Col sm={9} className="text-left">
                                                        <Form.Control
                                                            as="select"
                                                            size="sm"
                                                            name="fieldStatus"
                                                            value={fieldStatus || ''}
                                                            onChange={this.handleInputChange}
                                                        >
                                                            <option value="ACTIVE">ACTIVE</option>
                                                            <option value="INACTIVE">INACTIVE</option>
                                                        </Form.Control>
                                                        {!validator.status && showError ? (
                                                            <span className="error">Status is required</span>
                                                        ) : null}
                                                    </Col>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={12}>
                                                <div className="company-info">
                                                    <Form.Group className="form-inline">
                                                        <Form.Label
                                                            column
                                                            sm={3}
                                                            className="model-field-label text-nowrap"
                                                        >
                                                            Company Website{' '}
                                                        </Form.Label>
                                                        <Col sm={9} className="text-left">
                                                            <Form.Control
                                                                type="text"
                                                                id="company-website"
                                                                size="sm"
                                                                placeholder="Company Website"
                                                                name="fieldCompanyWebsite"
                                                                value={fieldCompanyWebsite || ''}
                                                                onChange={this.handleInputChange}
                                                                autoComplete="none"
                                                            />
                                                            {validator.companyWebsite && showError ? (
                                                                <span className="error">
                                                                    Company Website is required
                                                                </span>
                                                            ) : null}
                                                        </Col>
                                                    </Form.Group>

                                                    <Form.Group className="form-inline" controlId="fieldCompanyLogo">
                                                        <Form.Label
                                                            column
                                                            sm={3}
                                                            className="model-field-label text-nowrap"
                                                        >
                                                            Company Logo{' '}
                                                        </Form.Label>
                                                        <Col sm={9} className="text-left">
                                                            <Form.Control
                                                                type="file"
                                                                accept="image/*"
                                                                size="sm"
                                                                placeholder="Company Logo"
                                                                id="uploadimageFile"
                                                                name="fieldCompanyLogo"
                                                                onChange={this.onSelectLogo}
                                                            />
                                                            <small className="form-text text-muted">
                                                                Note: 130px*40px is the maximum resolution and 5MB is
                                                                the maximum size supported.
                                                            </small>
                                                        </Col>
                                                    </Form.Group>
                                                    <Col sm={12}>
                                                        {fieldCompanyLogo ? (
                                                            <div className="image-preview">
                                                                <img src={fieldCompanyLogo} alt="logo" />
                                                            </div>
                                                        ) : null}
                                                    </Col>
                                                    <Form.Group className="form-inline">
                                                        <Form.Label
                                                            column
                                                            sm={3}
                                                            className="model-field-label text-nowrap"
                                                        >
                                                            SFTP Access Granted ?
                                                        </Form.Label>

                                                        <div>
                                                            <ToggleButton
                                                                value={enableSFTP}
                                                                width={'50px'}
                                                                inactiveLabel={'NO'}
                                                                activeLabel={'YES'}
                                                                colors={{
                                                                    activeThumb: {
                                                                        base: 'rgb(247, 247, 247)',
                                                                    },
                                                                    inactiveThumb: {
                                                                        base: 'rgb(247, 247, 247)',
                                                                    },
                                                                    active: {
                                                                        base: 'rgb(26, 108, 157, 1)',
                                                                        hover: 'rgb(26, 108, 157, 1)',
                                                                    },
                                                                    inactive: {
                                                                        base: 'rgb(65,66,68)',
                                                                        hover: 'rgb(95,96,98)',
                                                                    },
                                                                }}
                                                                onToggle={(value) => {
                                                                    this.toggleSFTP(!value);
                                                                }}
                                                            />
                                                        </div>
                                                    </Form.Group>
                                                    <Form.Group className="form-inline">
                                                        <Form.Label
                                                            column
                                                            sm={3}
                                                            className="model-field-label text-nowrap"
                                                        >
                                                            EHR Integration Enabled
                                                        </Form.Label>

                                                        <div>
                                                            <ToggleButton
                                                                value={redox}
                                                                width={'50px'}
                                                                inactiveLabel={'NO'}
                                                                activeLabel={'YES'}
                                                                colors={{
                                                                    activeThumb: {
                                                                        base: 'rgb(247, 247, 247)',
                                                                    },
                                                                    inactiveThumb: {
                                                                        base: 'rgb(247, 247, 247)',
                                                                    },
                                                                    active: {
                                                                        base: 'rgb(26, 108, 157, 1)',
                                                                        hover: 'rgb(26, 108, 157, 1)',
                                                                    },
                                                                    inactive: {
                                                                        base: 'rgb(65,66,68)',
                                                                        hover: 'rgb(95,96,98)',
                                                                    },
                                                                }}
                                                                onToggle={(value) => {
                                                                    this.toggleRedOx(!value);
                                                                }}
                                                            />
                                                        </div>
                                                    </Form.Group>
                                                    {showAppointmentReferral && (
                                                        <Form.Group className="form-inline">
                                                            <Form.Label
                                                                column
                                                                sm={3}
                                                                className="model-field-label text-nowrap"
                                                            >
                                                                Appointment Referral Enabled
                                                            </Form.Label>

                                                            <div>
                                                                <ToggleButton
                                                                    value={appointmentReferral}
                                                                    width={'50px'}
                                                                    inactiveLabel={'NO'}
                                                                    activeLabel={'YES'}
                                                                    colors={{
                                                                        activeThumb: {
                                                                            base: 'rgb(247, 247, 247)',
                                                                        },
                                                                        inactiveThumb: {
                                                                            base: 'rgb(247, 247, 247)',
                                                                        },
                                                                        active: {
                                                                            base: 'rgb(26, 108, 157, 1)',
                                                                            hover: 'rgb(26, 108, 157, 1)',
                                                                        },
                                                                        inactive: {
                                                                            base: 'rgb(65,66,68)',
                                                                            hover: 'rgb(95,96,98)',
                                                                        },
                                                                    }}
                                                                    onToggle={(value) => {
                                                                        this.toggleAppointmentReferral(!value);
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="info-icon-div-cus" cursor="pointer">
                                                                <OverlayTrigger
                                                                    key={'top'}
                                                                    placement={'top'}
                                                                    overlay={
                                                                        <Tooltip id={`tooltip-top'`}>
                                                                            When enabled, a TherigySTM Integration User
                                                                            must be selected in order to save
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon
                                                                        className="info-icon-box-cus"
                                                                        icon={faInfoCircle}
                                                                    />
                                                                </OverlayTrigger>
                                                            </div>
                                                        </Form.Group>
                                                    )}
                                                    {appointmentReferral && (
                                                        <Form.Group className="form-inline">
                                                            <Form.Label
                                                                column
                                                                sm={3}
                                                                className="model-field-label text-nowrap required"
                                                            >
                                                                <div className="info-icon-div-cus" cursor="pointer">
                                                                    <OverlayTrigger
                                                                        key={'top'}
                                                                        placement={'top'}
                                                                        overlay={
                                                                            <Tooltip id={`tooltip-top'`}>
                                                                                Email address of API user needed for
                                                                                sending messages to to TherigySTM
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon
                                                                            className="info-icon-box-cus"
                                                                            icon={faInfoCircle}
                                                                        />
                                                                    </OverlayTrigger>
                                                                </div>
                                                                TherigySTM Integration User
                                                            </Form.Label>

                                                            <Col sm={9} className="text-left">
                                                                <Form.Control
                                                                    type="text"
                                                                    id="therigy-stm-int-user"
                                                                    size="sm"
                                                                    placeholder="Integration User Email Address"
                                                                    name="fieldTherigyStmIntUser"
                                                                    value={fieldTherigyStmIntUser || ''}
                                                                    onChange={this.handleInputChange}
                                                                    autoComplete="none"
                                                                    pattern="^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$"
                                                                    onBlur={this.handleFocusOutChange}
                                                                />
                                                                <FontAwesomeIcon
                                                                    icon={faSearch}
                                                                    className="search-icon search-icon-box"
                                                                />
                                                                {validator.therigyStmIntUser && showEmailError ? (
                                                                    <span className="error">
                                                                        Integration User Email Address is required.
                                                                        Please enter a valid email address.
                                                                    </span>
                                                                ) : null}
                                                            </Col>
                                                            {userList && userList.length ? (
                                                                <Col className="text-left col-12">
                                                                    <div
                                                                        className={`customer-search-box ${displayUserList}`}
                                                                        ref={this.setUserWrapperRef}
                                                                    >
                                                                        <ReactTable
                                                                            columns={userColumns}
                                                                            data={userList}
                                                                            loading={false}
                                                                            minRows={
                                                                                userList.length ? userList.length : 0
                                                                            }
                                                                            showPagination={false}
                                                                            pageSize={
                                                                                userList.length ? userList.length : 0
                                                                            }
                                                                            className="-striped -highlight h-100 cursor-pointer"
                                                                            getTrProps={(state, rowInfo) => {
                                                                                return {
                                                                                    onClick: () => {
                                                                                        this.onUserRowClick(rowInfo);
                                                                                    },
                                                                                };
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            ) : null}
                                                        </Form.Group>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={6}>
                                        <div className="right-pane">
                                            <div className={`created-info ${displayCreatedInfo}`}>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <FontAwesomeIcon icon={faCalendarAlt} />
                                                                <span className="ml-2">Created Date</span>
                                                            </td>
                                                            <td>
                                                                {' '}
                                                                {createdDate
                                                                    ? moment(
                                                                          createdDate,
                                                                          Config.API_TIMESTAMP_FORMAT,
                                                                      ).format(Config.UI_TIMESTAMP_FORMAT)
                                                                    : null}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <FontAwesomeIcon icon={faUser} />
                                                                <span className="ml-2">Created By</span>
                                                            </td>
                                                            <td> {customerData && customerData.createdBy}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <FontAwesomeIcon icon={faCalendarAlt} />
                                                                <span className="ml-2">Modified Date</span>
                                                            </td>
                                                            <td>
                                                                {' '}
                                                                {modifiedDate
                                                                    ? moment(
                                                                          modifiedDate,
                                                                          Config.API_TIMESTAMP_FORMAT,
                                                                      ).format(Config.UI_TIMESTAMP_FORMAT)
                                                                    : null}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <FontAwesomeIcon icon={faUser} />
                                                                <span className="ml-2">Modified By</span>
                                                            </td>
                                                            <td> {customerData && customerData.modifiedBy}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col sm={6}>
                                        <div className="left-pane">
                                            <Col className="col-12 text-center button-group mt-3">
                                                <Row className="flex-wrap">
                                                    <Col className="col-6 col-sm-6 col-md-6 col-lg-3 mb-lg-0 mb-2">
                                                        <Button
                                                            id="save-btn"
                                                            className="w-100 m-0 btn-save"
                                                            size="sm"
                                                            disabled={
                                                                fieldCustomerID && saveDisabled ? null : 'disabled'
                                                            }
                                                            onClick={this.saveCustomer}
                                                        >
                                                            <FontAwesomeIcon icon={faCheckCircle} />
                                                            <span className="ml-3">Save</span>
                                                        </Button>
                                                    </Col>
                                                    <Col className="col-6 col-sm-6 col-md-6 col-lg-3 mb-lg-0 mb-2">
                                                        <Button
                                                            id="cancel-btn"
                                                            className="w-100 m-0 btn-close"
                                                            size="sm"
                                                            onClick={this.cancelCustomer}
                                                        >
                                                            <FontAwesomeIcon icon={faTimesCircle} />
                                                            <span className="ml-3">Cancel</span>
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            \
                        </Tab>
                        {customerData && (
                            <Tab eventKey="file-management" className="bg-white" title="File Upload Management">
                                <>
                                    <Row className="toast-container">
                                        <Col md={12} className="pt-2">
                                            <Toast
                                                className="toast-container"
                                                show={showToast}
                                                onClose={this.toggleToast}
                                            >
                                                <Toast.Header
                                                    className={` ${
                                                        api.response.status !== 'Failure' ? 'success' : 'error'
                                                    }`}
                                                >
                                                    <img
                                                        src="holder.js/20x20?text=%20"
                                                        className="rounded mr-2"
                                                        alt=""
                                                    />
                                                    <strong className="mr-auto">{api.response.status}</strong>
                                                </Toast.Header>
                                                <Toast.Body>{api.response.message}</Toast.Body>
                                            </Toast>
                                        </Col>
                                    </Row>
                                    <div className="form-inline pgpEnabled">
                                        <div className="info-icon-div-cus toggle-pgp-label" cursor="pointer">
                                            <span className="ml-2 mr-2 toggle-label">Encryption Activated</span>
                                            <OverlayTrigger
                                                key={'top'}
                                                placement={'top'}
                                                overlay={
                                                    <Tooltip id={`tooltip-top'`}>
                                                        When activated, all uploads containing PHI will require a
                                                        public/private key pair to successfully upload data files.
                                                    </Tooltip>
                                                }
                                            >
                                                <FontAwesomeIcon className="info-icon-box-cus" icon={faInfoCircle} />
                                            </OverlayTrigger>
                                        </div>
                                        <ToggleButton
                                            value={pgpEnabled}
                                            width={'50px'}
                                            inactiveLabel={'NO'}
                                            activeLabel={'YES'}
                                            colors={{
                                                activeThumb: {
                                                    base: 'rgb(247, 247, 247)',
                                                },
                                                inactiveThumb: {
                                                    base: 'rgb(247, 247, 247)',
                                                },
                                                active: {
                                                    base: 'rgb(26, 108, 157, 1)',
                                                    hover: 'rgb(26, 108, 157, 1)',
                                                },
                                                inactive: {
                                                    base: 'rgb(65,66,68)',
                                                    hover: 'rgb(95,96,98)',
                                                },
                                            }}
                                            onToggle={(value) => {
                                                this.togglePGP(!value);
                                            }}
                                        />
                                    </div>
                                </>
                            </Tab>
                        )}
                        {customerData && (
                            <Tab
                                eventKey="whitelist-list"
                                className="bg-white"
                                title="SFTP Setup"
                                disabled={!enableSFTP}
                            >
                                <div>
                                    <div className="sftp-header">
                                        <div></div>
                                        <div className="tab-container">
                                            <Tabs selectedIndex={0} className="pt-2 pl-3 bg-white">
                                                <Tab eventKey="sftp-user-list" className="bg-white" title="Users">
                                                    <div>
                                                        <SftpUserlist customerData={customerData} />
                                                    </div>
                                                </Tab>
                                                <Tab eventKey="whitelist-list" className="bg-white" title="Whitelist">
                                                    <div>
                                                        <Whitelist customerData={customerData} />
                                                    </div>
                                                </Tab>
                                            </Tabs>
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                        )}
                        {customerData && (
                            <Tab eventKey="notification-list" className="bg-white" title="Notification">
                                <div>
                                    <h5 className="mb-0 mt-3 ml-2">Data Upload Status Notifications</h5>
                                    <div>
                                        <NotificationList customerData={customerData} />
                                    </div>
                                </div>
                            </Tab>
                        )}
                    </Tabs>
                </div>
            </div>
        );
    }

    /**
     * Save Or Update Customer
     */
    saveCustomer = () => {
        let {
            validator,
            customerData,
            fieldCustomerID,
            fieldCustomerName,
            fieldAddressLine1,
            fieldAddressLine2,
            fieldCity,
            fieldCustomerType,
            fieldS3BucketName,
            fieldState,
            fieldStatus,
            fieldZip,
            fieldCompanyWebsite,
            fieldTherigyStmIntUser,
            fieldCompanyLogo,
            enableSFTP,
            redox,
            appointmentReferral,
            searchBySelected,
            crmParentId,
        } = this.state;

        if (validator.customerType && validator.status && validator.s3BucketName) {
            let customerParam = {};
            if (customerData && customerData.customerId) {
                customerParam['customerId'] = customerData.customerId;
            }

            if (searchBySelected.includes('Branch')) {
                customerParam['parentCrmCustomerId'] = crmParentId;
            }

            customerParam['crmCustomerId'] = fieldCustomerID;
            customerParam['customerName'] = fieldCustomerName;
            customerParam['addressLine1'] = fieldAddressLine1;
            customerParam['addressLine2'] = fieldAddressLine2;
            customerParam['city'] = fieldCity;
            customerParam['customerType'] = fieldCustomerType ? fieldCustomerType : 'Pharmacy';
            customerParam['awsS3BucketName'] = fieldS3BucketName;
            customerParam['status'] = fieldStatus ? fieldStatus : 'ACTIVE';
            customerParam['state'] = fieldState ? fieldState : '';
            customerParam['zip'] = fieldZip ? fieldZip : '';
            customerParam['companyWebsite'] = fieldCompanyWebsite;
            customerParam['companyLogo'] = fieldCompanyLogo;
            customerParam['sftpEnabled'] = enableSFTP === true ? 1 : 0;
            customerParam['redox'] = redox === true ? 1 : 0;
            customerParam['appointmentReferral'] = appointmentReferral === true ? 1 : 0;

            if (appointmentReferral) {
                customerParam['therigyStmIntUser'] = fieldTherigyStmIntUser;
            } else {
                customerParam['therigyStmIntUser'] = null;
            }

            this.customerService.saveOrUpdateCustomer(customerParam).then((res) => {
                if (res && res.status === 'Success') {
                    this.setState({
                        showError: false,
                        api: {
                            response: {
                                status: res.status,
                                message: res.message,
                            },
                        },
                    });
                    swal({
                        title: res.status,
                        text: res.message + ', and you will be redirected to home page',
                        icon: 'success',
                        button: 'OK',
                    }).then(() => {
                        this.props.history.push('/model/list');
                    });
                } else {
                    this.setState({
                        showError: false,
                        api: {
                            response: {
                                status: res.status,
                                message: res.message,
                            },
                        },
                    });
                    this.toggleToast();
                }
            });
        } else {
            this.setState({
                showError: true,
            });
        }
    };

    /**
     * On click of Refresh from CRM button.
     */
    refreshDataFromCRM = () => {
        this.setState({
            disableRefreshButton: true,
            showRefreshLoader: true,
        });
        let params = {
            crmCustomerId: this.state.fieldCustomerID,
            customerName: this.state.fieldCustomerName,
        };
        // api call for refresh customer.
        this.customerService.refreshCustomer(params).then((res) => {
            if (res && res.status === 'Success') {
                setTimeout(() => {
                    this.setState({
                        disableRefreshButton: false,
                        showRefreshLoader: false,
                        fieldCustomerID: res.data.crmCustomerId,
                        fieldCustomerName: res.data.customerName,
                        fieldAddressLine1: res.data.addressLine1,
                        fieldAddressLine2: res.data.addressLine2,
                        fieldCity: res.data.city,
                        fieldState: res.data.state,
                        fieldZip: res.data.zip,
                        api: {
                            response: {
                                status: 'Success',
                                message: 'Refreshed Successfully',
                            },
                        },
                    });
                    this.toggleToast();
                }, 1000);
            } else {
                this.setState({
                    showError: false,
                    api: {
                        response: {
                            status: res.status,
                            message: res.message,
                        },
                    },
                });
                this.toggleToast();
                this.setState({
                    disableRefreshButton: false,
                    showRefreshLoader: false,
                });
            }
        });
    };

    /**
     * Reset form to previous state
     */
    resetCustomer = () => {
        const { validator } = this.state;
        swal({
            title: 'Are you sure to reset?',
            text: 'You will not be able to recover unsaved customer!',
            icon: 'warning',
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                document.getElementById('uploadimageFile').value = '';
                if (this.state.customerData.customerId) {
                    this.getCustomer(this.state.customerData.customerId);
                    setTimeout(() => {
                        this.setState({
                            showError: false,
                            api: {
                                response: {
                                    status: 'Success',
                                    message: 'Reset Successfully',
                                },
                            },
                        });
                        this.toggleToast();
                    }, 1000);
                } else {
                    this.setState({
                        fieldSearchCustomer: '',
                        fieldCustomerID: '',
                        fieldCustomerName: '',
                        fieldAddressLine1: '',
                        fieldAddressLine2: '',
                        fieldCity: '',
                        fieldState: '',
                        fieldStatus: '',
                        fieldZip: '',
                        fieldS3BucketName: '',
                        fieldCompanyLogo: '',
                        customersList: [],
                        validator: {
                            customerType: validator.customerType,
                            status: validator.status,
                            s3BucketName: validator.s3BucketName,
                        },
                    });
                }
            }
        });
    };

    /**
     * Delete custmer and navigate to list
     */
    deleteCustomer = () => {
        const { customerData } = this.state;
        if (customerData && customerData.customerId) {
            swal({
                title: 'Are you sure to delete?',
                text: 'You will not be able to recover this!',
                icon: 'warning',
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    this.customerService.deleteCustomer(customerData.customerId).then((res) => {
                        if (res && res.status === 'Success') {
                            this.setState({
                                showError: false,
                                api: {
                                    response: {
                                        status: res.status,
                                        message: res.message,
                                    },
                                },
                            });
                            swal({
                                title: res.status,
                                text: res.message + ', and you will be redirected to home page',
                                icon: 'success',
                                button: 'OK',
                            }).then(() => {
                                this.props.history.push('/model/list');
                            });
                        } else {
                            this.setState({
                                showError: false,
                                api: {
                                    response: {
                                        status: res.status,
                                        message: res.message,
                                    },
                                },
                            });
                            this.toggleToast();
                        }
                    });
                }
            });
        } else {
            swal('Warning!', 'No valid customer data', 'warning', {
                button: 'OK',
            });
        }
    };

    /**
     * Cancel customer and navigate to list
     */
    cancelCustomer = () => {
        this.props.history.push('/model/list');
    };

    /**
     * Component mounting invoking func
     */
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('mousedown', this.handleClickUserOutside);
        if (this.props.match.params.customerId) {
            this.setState({
                showCustomerList: false,
            });
            this.getCustomer(this.props.match.params.customerId);
            this.getUser(this.props.match.params.customerId);
        }
    }

    /**
     * Invoke if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.customerWrapperRef && !this.customerWrapperRef.contains(event.target)) {
            this.setState({ showCustomerList: false });
        }
    }

    /**
     * Invoke if clicked on outside of element
     */
    handleClickUserOutside(event) {
        if (this.userWrapperRef && !this.userWrapperRef.contains(event.target)) {
            this.setState({ showUserList: false });
        }
    }

    handleSearchBySelectedClick(event) {
        this.setState({
            searchBySelected: [event.target.value],
        });
    }

    setCustomerWrapperRef(node) {
        this.customerWrapperRef = node;
    }

    setUserWrapperRef(node) {
        this.userWrapperRef = node;
    }

    /**
     * get model details using modelId and versionId
     */
    getCustomer = (customerId) => {
        this.customerService.getCustomer(customerId).then((res) => {
            if (res.status === 'Success' && res.data) {
                this.setState({
                    customerData: res.data,
                    createdDate: moment.utc(res.data.createdDate, Config.UI_TIMESTAMP_FORMAT).local(),
                    modifiedDate: moment.utc(res.data.modifiedDate, Config.UI_TIMESTAMP_FORMAT).local(),
                    fieldCustomerID: res.data.crmCustomerId,
                    fieldCustomerName: res.data.customerName,
                    fieldAddressLine1: res.data.addressLine1,
                    fieldAddressLine2: res.data.addressLine2,
                    fieldCity: res.data.city,
                    fieldCustomerType: res.data.customerType,
                    fieldState: res.data.state,
                    fieldZip: res.data.zip,
                    fieldStatus: res.data.status,
                    fieldCompanyWebsite: res.data.companyWebsite,
                    fieldTherigyStmIntUser: res.data.therigyStmIntUser,
                    fieldS3BucketName: res.data.awsS3BucketName ? res.data.awsS3BucketName : '',
                    fieldCompanyLogo: res.data.companyLogo,
                    validator: {
                        customerName: res.data.customerName ? true : false,
                        customerType: res.data.customerType ? true : false,
                        s3BucketName: res.data.awsS3BucketName ? true : false,
                        status: res.data.status ? true : false,
                    },
                    enableSFTP: res.data.sftpEnabled === 1 ? true : false,
                    redox: res.data.redox === 1 ? true : false,
                    appointmentReferral: res.data.appointmentReferral === 1 ? true : false,
                    pgpEnabled: res.data.pgpEnabled === 1 ? true : false,
                });
            }
        });
    };

    /**
     * get model details using modelId and versionId
     */
    getUser = (customerId) => {
        this.customerService.getUser(customerId).then((res) => {
            if (res.status === 'Success' && res.data) {
                if (res.data.length > 0) {
                    this.setState({
                        showAppointmentReferral: true,
                        userList: res.data,
                    });
                }
            }
        });
    };
}

export const convertLogoToBase64 = (file) => {
    return new Promise((resolve) => {
        var reader = new FileReader();
        reader.addEventListener('load', function () {
            resolve(this.result);
        });
        reader.readAsDataURL(file);
    });
};

CustomerView.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

export default withRouter(CustomerView);
